import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

// Only disable console.log in production builds
// if (process.env.NODE_ENV !== "development") {
//     console.log = () => {};
// }

// Suppress known third-party library warnings and errors early
const originalWarn = console.warn;
const originalError = console.error;

console.warn = (...args) => {
  const message = args[0]?.toString() || '';
  
  // Suppress @emotion/react duplicate loading warning from react-google-places-autocomplete
  if (message.includes('@emotion/react') && message.includes('already loaded')) {
    return;
  }
  originalWarn.apply(console, args);
};

console.error = (...args) => {
  const message = args[0]?.toString() || '';
  
  // Suppress react-scroll-section setState during render warning
  if (
    (message.includes('Cannot update a component') || message.includes('Warning: Cannot update')) &&
    message.includes('while rendering a different component')
  ) {
    return;
  }
  
  // Also suppress if it mentions react-scroll-section specifically
  if (message.includes('react-scroll-section') && message.includes('setState')) {
    return;
  }
  
  originalError.apply(console, args);
};

const container = document.getElementById('root');
// console.log('Root element:', container);

if (!container) {
  console.error('Failed to find root element');
} else {
  const root = createRoot(container);
  // console.log('Rendering App component...');

  // StrictMode is temporarily disabled due to incompatibility with react-scroll-section library
  // which triggers setState during render. This is a known issue with the library and doesn't
  // affect functionality. You can re-enable StrictMode when the library is updated or replaced.
  root.render(
    <App />
  );
  
  // Alternative: Keep StrictMode but suppress the specific warning
  // Uncomment below and comment out the above render if you prefer to keep StrictMode:
  /*
  const originalError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('Cannot update a component') &&
      args[0].includes('while rendering a different component')
    ) {
      return; // Suppress this specific react-scroll-section warning
    }
    originalError.apply(console, args);
  };
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  */
}
